import * as React from 'react'
import classNames from 'classnames'
import { useParams } from 'react-router-dom'

import DisplayTime from './DisplayTime'
import { useMultipleStops } from '../hooks/useMultipleStops.hook'
import { IRTIS3_MAX_AMOUNT_OF_STOPS } from '../constants'

export default function Header() {
  const { haltenummers } = useParams()
  const stopIds = (haltenummers as string)
    .split('+')
    .slice(0, IRTIS3_MAX_AMOUNT_OF_STOPS)

  const shouldFetch = stopIds.length === 1
  const { stops = [] } = useMultipleStops({ stopIds, shouldFetch })
  const [stop] = stops

  const headerClasses = classNames(
    'flex flex-row gap-4 h-24 max-h-24 justify-between items-center px-2.5',
    'bg-primary-grey text-neutral-100 font-flanders text-5xl font-bold',
    'border-0 border-solid border-b border-neutral-550',
  )
  return (
    <header className={headerClasses}>
      <DisplayTime />
      {stop && (
        <h2 className="text-[56px] truncate">{stop.shortDescription}</h2>
      )}
      <span>vertrek</span>
    </header>
  )
}
